module.exports = __webpack_public_path__ + "static/screen_10-4893e536cca5cebeb2f7e146daec2995.png";